"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductsList = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const dataview_1 = require("primereact/dataview");
const ListItem_1 = require("./ListItem");
const FiltersComponent_1 = require("../FiltersComponent");
const editor_module_scss_1 = __importDefault(require("./editor.module.scss"));
const progressspinner_1 = require("primereact/progressspinner");
const react_router_dom_1 = require("react-router-dom");
const constants_1 = require("../../../routes/constants");
const ListItemSkeleton_1 = require("./ListItemSkeleton");
const react_i18next_1 = require("react-i18next");
const ProductsList = ({ products, handleEdit, handleDelete, globalFilterValue, onGlobalFilterChange, fetchData, loading, pagination, }) => {
    const observerRef = (0, react_1.useRef)(null);
    const { t } = (0, react_i18next_1.useTranslation)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const loadMore = (0, react_1.useCallback)(() => {
        if (!pagination || !fetchData)
            return;
        if (!loading && pagination.currentPage < pagination.totalPages) {
            fetchData(pagination.currentPage + 1, pagination.pageSize, true);
        }
    }, [loading, pagination, fetchData]);
    (0, react_1.useEffect)(() => {
        const observer = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting) {
                loadMore();
            }
        }, { threshold: 0.99 });
        if (observerRef.current) {
            observer.observe(observerRef.current);
        }
        return () => {
            if (observerRef.current) {
                observer.unobserve(observerRef.current);
            }
        };
    }, [loadMore]);
    return ((0, jsx_runtime_1.jsxs)("div", { className: "overflow-auto flex-1", style: { paddingTop: '146px' }, children: [(0, jsx_runtime_1.jsx)(dataview_1.DataView, { value: loading && products && products?.length <= 0
                    ? Array(10).fill({})
                    : products, style: { marginBottom: '80px' }, header: header(globalFilterValue, onGlobalFilterChange, navigate), emptyMessage: t('noRecords'), itemTemplate: (p) => loading && products && products?.length <= 0 ? ((0, jsx_runtime_1.jsx)(ListItemSkeleton_1.ListItemSkeleton, {})) : ((0, jsx_runtime_1.jsx)(ListItem_1.ListItem, { product: p, handleEdit: handleEdit, handleDelete: handleDelete })) }), (0, jsx_runtime_1.jsx)("div", { ref: observerRef, style: { height: '1px' } }), loading && products && products?.length > 0 && ((0, jsx_runtime_1.jsx)("div", { className: "loading-spinner", children: (0, jsx_runtime_1.jsx)(progressspinner_1.ProgressSpinner, { style: { width: '25px', height: '25px' }, strokeWidth: "6", fill: "var(--surface-ground)", animationDuration: ".5s" }) }))] }));
};
exports.ProductsList = ProductsList;
const header = (globalFilterValue, onGlobalFilterChange, navigate) => {
    return ((0, jsx_runtime_1.jsx)("div", { style: { backgroundColor: 'rgb(231,238,248)' }, className: "shadow-md p-4", children: (0, jsx_runtime_1.jsx)("div", { className: "w-full flex justify-between items-center", children: (0, jsx_runtime_1.jsxs)("div", { className: editor_module_scss_1.default.buttonTopContainer, children: [(0, jsx_runtime_1.jsx)(FiltersComponent_1.FiltersComponent, { globalFilterValue: globalFilterValue ?? '', onGlobalFilterChange: onGlobalFilterChange ?? (() => { }) }), (0, jsx_runtime_1.jsx)("div", { className: 'flex items-center', onClick: () => navigate(constants_1.ROUTE_PRODUCTS_CREATE), children: (0, jsx_runtime_1.jsx)("i", { className: 'pi pi-plus-circle text-4xl text-blue-950' }) })] }) }) }));
};
